import { FILTER_TYPES, DEFAULT_RANGE } from '../global-constants';

const getMakeFilterLabel = (make) => {
	if (typeof window.DDC?.LocationsData?.getMakeFacets === 'function') {
		const allMakes = window.DDC.LocationsData.getMakeFacets();
		const makeFacet = allMakes.find((facet) => facet.value === make);
		if (makeFacet) {
			return makeFacet.label;
		}
	}
	return make;
};

export const prepareMakeFilters = (items) => {
	if (!items || !Array.isArray(items)) {
		return [];
	}

	return items.map((item) => ({
		id: item,
		label: getMakeFilterLabel(item),
		type: FILTER_TYPES.MAKE
	}));
};

export const prepareRadiusFilter = (radius, labels) => {
	if (
		radius == null ||
		typeof radius !== 'number' ||
		radius === DEFAULT_RANGE
	) {
		return null;
	}

	return {
		id: 'radius',
		label: labels
			.get('X_MI_AWAY_FROM_CENTER')
			.replace('{distance}', radius),
		type: FILTER_TYPES.RADIUS
	};
};
